import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const HelpIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8Zm6.75 4c0 .75.5 1.25 1.25 1.25s1.25-.5 1.25-1.25-.5-1.25-1.25-1.25-1.25.5-1.25 1.25ZM9 9c0-.2 0-.3.5-.6.6-.4 1.5-1 1.5-2.4 0-1.7-1.3-3-3-3-1.1 0-2.1.6-2.6 1.5l-.033.06a.986.986 0 0 0 1.724.957L7.1 5.5c.2-.3.5-.5.9-.5.6 0 1 .4 1 1 0 .3-.1.4-.6.7C7.8 7.1 7 7.7 7 9a1 1 0 1 0 2 0Z", fill: "currentColor" })));
});
HelpIcon.displayName = 'HelpIcon';
export default HelpIcon;
